module.exports = __webpack_public_path__ + "static/media/Generic.9d952e90.jpg";